// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.TxtableFooter{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.TxTableButton{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 7px;
}

.TxTableButton button{
    border: 1px solid #E84427;
    outline: none;
    border-radius: 6px;
    width: 3rem;
    height: 2rem;
    background: transparent;
    padding: 4px;
    font-weight: 500;
    font-size: 16px;
    color: #515151;
    display: flex;
    align-items: center;
    justify-content: center;
}

.TxTableButton button:hover{
    border-width: 2px  !important;
    font-weight: 700;
}

.TxtableFooter span{
    color: #000000;
    font-size: 16px;
}

.tnxhtrbdytbl tr > td, .tnxHistoryheader > tr > th{
    text-align: left;
}
.tnxhtrbdytbl tr > td:last-child > span{
    cursor: pointer;
}

.table-responsive {
    min-width: 1050px;
    width: 100%;
}

.sorttablebtn ul{
    min-width: 120px;
    background-color: #eaeaecfb;
    color: #000000;
    border: 1px solid #234b9a;
}

.activePaginationbtn{
    background-color: #E84427 !important;
    color: #FFFFFF !important;
}

.widthRespos{
    width: 100%;
    border-radius: 6px;
    overflow-x: auto;
}

.tnxTable_main > h1:first-child{
    font-size: 24px;
    font-weight: 600;
}

.widthRespos::-webkit-scrollbar{
    display: none;
}

.data_not {
    text-align: center!important;
    font-weight: bold!important;
    padding: 20px!important;
  }
  


@media screen and (max-width: 767px){
    .TxtableFooter{
        justify-content: center;
        gap: 10px;
    }
    

}`, "",{"version":3,"sources":["webpack://./src/Pages/Migration/TxTable.css"],"names":[],"mappings":";;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;EACzB;;;;AAIF;IACI;QACI,uBAAuB;QACvB,SAAS;IACb;;;AAGJ","sourcesContent":["\n\n.TxtableFooter{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.TxTableButton{\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 7px;\n}\n\n.TxTableButton button{\n    border: 1px solid #E84427;\n    outline: none;\n    border-radius: 6px;\n    width: 3rem;\n    height: 2rem;\n    background: transparent;\n    padding: 4px;\n    font-weight: 500;\n    font-size: 16px;\n    color: #515151;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.TxTableButton button:hover{\n    border-width: 2px  !important;\n    font-weight: 700;\n}\n\n.TxtableFooter span{\n    color: #000000;\n    font-size: 16px;\n}\n\n.tnxhtrbdytbl tr > td, .tnxHistoryheader > tr > th{\n    text-align: left;\n}\n.tnxhtrbdytbl tr > td:last-child > span{\n    cursor: pointer;\n}\n\n.table-responsive {\n    min-width: 1050px;\n    width: 100%;\n}\n\n.sorttablebtn ul{\n    min-width: 120px;\n    background-color: #eaeaecfb;\n    color: #000000;\n    border: 1px solid #234b9a;\n}\n\n.activePaginationbtn{\n    background-color: #E84427 !important;\n    color: #FFFFFF !important;\n}\n\n.widthRespos{\n    width: 100%;\n    border-radius: 6px;\n    overflow-x: auto;\n}\n\n.tnxTable_main > h1:first-child{\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.widthRespos::-webkit-scrollbar{\n    display: none;\n}\n\n.data_not {\n    text-align: center!important;\n    font-weight: bold!important;\n    padding: 20px!important;\n  }\n  \n\n\n@media screen and (max-width: 767px){\n    .TxtableFooter{\n        justify-content: center;\n        gap: 10px;\n    }\n    \n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
